import {
  Component, Input, OnInit, TemplateRef
} from '@angular/core';
import {ActivatedRoute, RouterLink} from "@angular/router";
import { ThemePalette } from "@angular/material/core";
import {
  LoaderContainerComponent,
  SrsLoaderOptions,
  SrsLoaderType
} from "../loader-container/loader-container.component";
import {RouterLinkType} from "../../model/common.model";
import {JsonPipe, NgClass, NgIf, NgTemplateOutlet} from "@angular/common";
import {RouteContainerComponent} from "../route-container/route-container.component";
import {QuickPreviewPanelComponent} from "../quick-preview-panel/quick-preview-panel.component";


@Component({
  selector: 'quick-card',
  standalone: true,
  imports: [
    JsonPipe,
    NgIf,
    RouteContainerComponent,
    NgTemplateOutlet,
    LoaderContainerComponent,
    QuickPreviewPanelComponent,
    RouterLink,
    NgClass
  ],
  templateUrl: './quick-card.component.html'
})
export class QuickCardComponent<TResult> implements OnInit {

  @Input() debug = true
  @Input() uid?: string
  @Input() loaderOptions: SrsLoaderOptions<TResult> = {}
  @Input() loader?: SrsLoaderType<TResult>
  @Input() routerLink: RouterLinkType
  @Input() headingIconKey?: string
  @Input() headingColor?: ThemePalette
  @Input() heading?: string
  @Input() innerContentTemplate?: TemplateRef<any>
  @Input() hasRouterOutlet: boolean = false

  loadedResult?: TResult

  constructor(
    readonly activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
  }

  onLoadComplete(result: TResult) {
    this.loadedResult = result
  }
}
